<template>
  <div id="filters">
    <ul class="row no-gutters mb-n1 c-lg:mb-n2 ml-n1 c-lg:ml-n2 c-pb-3 c-md:c-pb-4 c-lg:c-pb-5 c-xl:c-pb-6 list-unstyled">
      <li
        v-for="property in properties"
        :key="property"
        class="col-auto c-pb-1 c-lg:c-pb-2 c-pl-1 c-lg:c-pl-2"
      >
        <button
          type="button"
          class="btn c-py-1 c-sm:c-py-2 c-px-2 c-md:c-px-3 c-lg:c-px-4 font-medium c-rounded-pill"
          :class="isInFilter(property.systemName) ? 'btn-primary' : 'btn-outline-primary'"
          @click="productStore.toggleFilter(property.systemName)"
        >
          <i :class="[`mi-${property.icon} hidden c-sm:block my-n1 c-mr-2 c-lg:c-mr-3 mi-no-mx icon-filter`]" />
          <span class="hidden c-md:block">{{ property.name }}</span>
          <span class="small c-md:hidden">{{ property.name }}</span>
          <i
            v-if="isInFilter(property.systemName)"
            class="mi-times c-ml-1 c-sm:c-ml-2 c-lg:c-ml-3"
          />
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useProductStore } from '@/stores/ProductStore'

const { t } = useI18n()
const productStore = useProductStore()
const { isInFilter } = storeToRefs(productStore)

const properties = [
  {
    name: t('for_vegan'),
    systemName: 'for_vegan',
    icon: 'vegan',
  },
  {
    name: t('no_lactose'),
    systemName: 'no_lactose',
    icon: 'no-lactose',
  },
  {
    name: t('no_gluten'),
    systemName: 'no_gluten',
    icon: 'no-gluten',
  },
  {
    name: t('no_added_sugar'),
    systemName: 'no_added_sugar',
    icon: 'no-sugar',
  },
  {
    name: t('discount'),
    systemName: 'discount',
    icon: 'discount',
  },
  {
    name: t('protein'),
    systemName: 'protein',
    icon: 'protein',
  },
]
</script>

<style lang="scss">
.icon-filter{ font-size: 24px; }
</style>

<i18n>
  {
    "cs": {
    "discount": "Mixy v akci",
    "for_vegan": "Vegan",
    "no_added_sugar": "Bez přidaného cukru",
    "no_gluten": "Bez lepku",
    "no_lactose": "Bez laktózy",
    "protein": "Protein"
},
    "sk": {
    "discount": "Mixy v akcii",
    "for_vegan": "Vegán",
    "no_added_sugar": "Bez pridaného cukru",
    "no_gluten": "Bez lepku",
    "no_lactose": "Bez laktózy",
    "protein": "Proteín"
},
    "pl": {
    "discount": "Mixy w promocji",
    "for_vegan": "Wegański",
    "no_added_sugar": "Bez dodatku cukru",
    "no_gluten": "Bez glutenu",
    "no_lactose": "Bez laktozy",
    "protein": "Proteina"
},
    "hu": {
    "discount": "Akciós Mixit",
    "for_vegan": "Vegán",
    "no_added_sugar": "Hozzáadott cukor nélkül",
    "no_gluten": "Gluténmentes",
    "no_lactose": "Laktózmentes",
    "protein": "Fehérje"
},
    "de": {
    "discount": "Aktion",
    "for_vegan": "Vegan",
    "no_added_sugar": "Ohne Zuckerzusatz",
    "no_gluten": "Glutenfrei",
    "no_lactose": "Laktosefrei",
    "protein": "Protein"
},
    "at": {
    "discount": "Aktion",
    "for_vegan": "Vegan",
    "no_added_sugar": "Ohne Zuckerzusatz",
    "no_gluten": "Glutenfrei",
    "no_lactose": "Laktosefrei",
    "protein": "Protein"
},
    "ro": {
    "discount": "Amestecuri cu reducere",
    "for_vegan": "Vegan",
    "no_added_sugar": "Fără zahăr adăugat",
    "no_gluten": "Fără gluten",
    "no_lactose": "Fără lactoză",
    "protein": "Proteine"
},
    "fr": {
    "discount": "Mix en promotion",
    "for_vegan": "Végan",
    "no_added_sugar": "Sans sucre ajouté",
    "no_gluten": "Sans gluten",
    "no_lactose": "Sans lactose",
    "protein": "Protéines"
},
    "it": {
    "discount": "Mix in promozione",
    "for_vegan": "Vegan",
    "no_added_sugar": "Senza zuccheri aggiunti",
    "no_gluten": "Senza glutine",
    "no_lactose": "Senza lattosio",
    "protein": "Proteine"
}
  }
</i18n>
